import React, { useEffect, useState, useCallback } from 'react';
import Header from '../../../Components/Dashboard/Header/Header';
import Sidebar from '../../../Components/Dashboard/Sidebar/Sidebar';
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Apiurl, GetToken } from '../../../Utils/utils';
import axios from 'axios';
import * as XLSX from "xlsx";
import "../../HRScreens/AttendanceSheet/AttendanceSheet.css";
import { toast } from 'react-toastify';
import Loader from '../../../Components/loader/loader';
import moment from 'moment';
import DatePicker from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';

const EmployeeAttendanceSheet = () => {
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const LoginToken = GetToken();
  const [items, setItems] = useState([]);

  const [file, setFile] = useState(null);
  const [hideshowinputs, sethideshowinputs] = useState(false);
  const currentDate = new Date().toISOString().split("T")[0];

  const [earlyclosure, setEarlyclosure] = useState('');
  const [closureTime, setclosureTime] = useState("");

  const [officeTimings, setOfficeTimings] = useState({
    officeInTime: '',
    officeOutTime: '',
    lunchStartTime: '',
    lunchEndTime: '',
    morningShortTime: '',
    eveningShortTime: '',
    graceInTime: '',
    graceOutTime: '',
    satEveningSltime: '',
    satMorningHdtime: '',
    satOfficeOutTime: '',
  });

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const validateFields = () => {
    if (!file) {
      toast.error("Please Upload File");
      return false;
    }
    return true;
  };

  const handleimportattendance = () => {
    if (!validateFields()) return;
    setLoading(true);

    let formData = new FormData();
    formData.append('formFile', file);

    const option = {
      method: "POST",
      headers: {
        "content-type": "multipart/form-data",
        authorization: `Bearer ${LoginToken}`,
      },
      data: formData,
      url: `${Apiurl()}/Attendence/ImportAttendence`,
    };

    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          toast.success("Excel file imported successfully");
          setFile("");
          window?.location?.reload();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
        setItems(Array.isArray(jsonData) ? jsonData : []);

        const xlsxData = XLSX.write(workbook, {
          bookType: 'xlsx',
          bookSST: true,
          type: 'array'
        });

        const blob = new Blob([xlsxData], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'converted_file.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      };

      reader.readAsBinaryString(selectedFile);
    }
  };

  const convertAttendance = () => {
    sethideshowinputs(false);
  };

  const UploadAttendanceSheet = () => {
    sethideshowinputs(!hideshowinputs);
  };

  const validationEarlyClosure = () => {
    if (earlyclosure === "") {
      toast.error("Please select choose date");
      return false;
    }
    if (closureTime === "") {
      toast.error("Please select out time");
      return false;
    }
    return true;
  };

  const AddClosureTime = () => {
    if (!validationEarlyClosure()) return;

    const data = {};
    data.Date = earlyclosure;
    data.EarlyClosureOuttime = moment(new Date(closureTime)).format("HH:mm:ss.SS");

    setLoading(true);

    const option = {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/AddClosureTime`,
      data: { data: JSON.stringify(data) },
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setEarlyclosure('');
          setclosureTime('');
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const handleOfficeTimingsChange = (field, value) => {
    setOfficeTimings((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const fetchTimings = useCallback(() => {
    const option = {
      method: "GET",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Setting/GetTimings`,
    };

    axios(option)
      .then((response) => {
        if (response?.status === 200 && response?.data?.data?.length) {
          setOfficeTimings(response.data.data[0]);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Failed to fetch timings");
      });
  }, [LoginToken]);

  const handleSaveTimings = () => {
    setLoading(true);

    const timingsData = {
      ...officeTimings
    };

    const option = {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      data: { data: JSON.stringify(timingsData) },
      url: `${Apiurl()}/Setting/SaveTiming`,
    };

    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          toast.success("Office timings saved successfully");
          fetchTimings();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message || "Error saving timings");
      });
  };

  useEffect(() => {
    fetchTimings();

    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }

    setShowSidebar(true);
  }, [fetchTimings]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div>
        <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
        <div className="d-flex">
          <Sidebar showSidebar={showSidebar} />
          <div
            className={
              showSidebar
                ? "EMP-main-container-of-all-employees-sheet"
                : "EMP-main-container-of-all-employees-page-new-sheet"
            }
          >
            <div className="EMP-inner-container-of-all-employees-page ">
              <div className="header-of-employees-page row">
                <div className="EMP-all-employee-sheet col">
                  <h4>Excel Attendance Sheet</h4>
                </div>
                <div className="EMP-all-employees-sheet col">
                  <div className="EMP-home-icon-sheet">
                    <BiHomeAlt className="EMP-home-icon-header-sheet" />
                  </div>
                  <div className="EMP-arrow-icon-sheet">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="EMP-employee-text-sheet">
                    <p>Attendance</p>
                  </div>
                  <div className="EMP-arrow-icon-sheet">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="EMP-all-employee-text-sheet">
                    <p>Attendance Sheet</p>
                  </div>
                </div>
              </div>

              <div className='excel-sheet-uploarder'>
                <div />
                <div className='excel-sheet-uploarder-inner-container'>
                  <div className='Excel-Sheet-uploder'>
                    {hideshowinputs ? (
                      <div className='all-data'>
                        <div className='attendanceuploder-uploder-inputone'>
                          <input type="file" onChange={handleFileChange} />
                        </div>
                        <button
                          className='attendanceuploder-button'
                          onClick={handleimportattendance}
                        >
                          Submit
                        </button>
                      </div>
                    ) : (
                      <div className='attendanceuploder-uploder-input'>
                        <input type="file" onChange={handleFileUpload} />
                      </div>
                    )}
                  </div>

                  {hideshowinputs ? (
                    <button
                      className='UploadAttendance'
                      onClick={convertAttendance}
                    >
                      Convert Attendance Sheet
                    </button>
                  ) : (
                    <button
                      className='UploadAttendance'
                      onClick={UploadAttendanceSheet}
                    >
                      Upload Attendance Sheet
                    </button>
                  )}
                </div>
              </div>

              <hr className='office-timings-divider' />

              <div className='office-timings-main-section'>
                <div className='office-timings-section'>
                  <h4 className='office-timings-heading'>Early Closure</h4>
                  <div className='early-closure-container'>
                    <div className="Earlyclosure-input col">
                      <label>Choose date</label>
                      <input
                        type="date"
                        value={earlyclosure}
                        onChange={(e) => setEarlyclosure(e.target.value)}
                        max={currentDate}
                      />
                    </div>
                    <div className='Earlyclosure-input col'>
                      <label>Out time</label>
                      <DatePicker
                        plugins={[<TimePicker />]}
                        format="HH:mm ss"
                        value={closureTime}
                        disableDayPicker
                        onChange={(date) => setclosureTime(new Date(date))}
                      />
                    </div>
                  </div>
                  <button onClick={AddClosureTime} className='early-closure-button'>
                    Submit
                  </button>
                </div>
              </div>

              <hr className='office-timings-divider' />

              <div className='office-timings-main-section'>
                <div className='office-timings-section'>
                  <h4 className='office-timings-heading'>Office Timings</h4>

                  <div className='office-timings-container'>
                    <h5 className="office-sub-heading">Employee</h5>

                    <div className='office-timing-row'>
                      <div className='office-timing-field'>
                        <label>In-Time</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.officeInTime}
                          onChange={(e) => handleOfficeTimingsChange('officeInTime', e.target.value)}
                        />
                      </div>
                      <div className='office-timing-field'>
                        <label>Out-Time</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.officeOutTime}
                          onChange={(e) => handleOfficeTimingsChange('officeOutTime', e.target.value)}
                        />
                      </div>
                      <div className='office-timing-field'>
                        <label>Lunch Start Time</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.lunchStartTime}
                          onChange={(e) => handleOfficeTimingsChange('lunchStartTime', e.target.value)}
                        />
                      </div>
                      <div className='office-timing-field'>
                        <label>Lunch End Time</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.lunchEndTime}
                          onChange={(e) => handleOfficeTimingsChange('lunchEndTime', e.target.value)}
                        />
                      </div>
                    </div>

                    <div className='office-timing-row'>
                      <div className='office-timing-field'>
                        <label>Short Leave Time(Morning)</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.morningShortTime}
                          onChange={(e) => handleOfficeTimingsChange('morningShortTime', e.target.value)}
                        />
                      </div>
                      <div className='office-timing-field'>
                        <label>Short Leave Time(Evening)</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.eveningShortTime}
                          onChange={(e) => handleOfficeTimingsChange('eveningShortTime', e.target.value)}
                        />
                      </div>
                      <div className='office-timing-field'>
                        <label>Grace In-Time</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.graceInTime}
                          onChange={(e) => handleOfficeTimingsChange('graceInTime', e.target.value)}
                        />
                      </div>
                      <div className='office-timing-field'>
                        <label>Grace Out-Time</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.graceOutTime}
                          onChange={(e) => handleOfficeTimingsChange('graceOutTime', e.target.value)}
                        />
                      </div>
                    </div>

                    <div className='office-timing-row'>
                      <div className='office-timing-field'>
                        <label>Evening ShortLeave Time(Saturday)</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.satEveningSltime}
                          onChange={(e) => handleOfficeTimingsChange('satEveningSltime', e.target.value)}
                        />
                      </div>
                      <div className='office-timing-field'>
                        <label>Morning ShortLeave Time(Saturday)</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.satMorningHdtime}
                          onChange={(e) => handleOfficeTimingsChange('satMorningHdtime', e.target.value)}
                        />
                      </div>
                      <div className='office-timing-field'>
                        <label>Out-Time(Saturday)</label>
                        <input
                          type="time"
                          className="timing-input"
                          value={officeTimings.satOfficeOutTime}
                          onChange={(e) => handleOfficeTimingsChange('satOfficeOutTime', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <button className='save-timings-button' onClick={handleSaveTimings}>
                    Save Timing
                  </button>
                </div>
              </div>

              <table className="table container" style={{ display: 'none' }}>
                <tbody>
                  {items.map((d, index) => (
                    <tr key={d.InputA || index}>
                      <th>{d.InputA || "-"}</th>
                      <td>{d.InputB || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeAttendanceSheet;